<script>
    import Question from "./Question.svelte";
    import Heading from "./Heading.svelte";

    async function getHelpContent() {
        let content = await (await fetch(`${document.location.protocol}//${document.location.host}/faq.txt`)).text();

        console.log(content);
        let sections = content.split(">>section-");

        let result = [];

        for (let section of sections) {
            if (!section) continue;
            if (section.trim().length == 0) continue;

            let questions = section.split(">>question-");

            for (let i = 0; i <= questions.length - 1; i++) {
                let faq = questions[i];

                if (!faq) continue;
                if (faq.trim().length == 0) continue;

                if (i == 0) {
                    result.push({ type: "section", title: faq });
                    continue;
                }

                let [ question, answer ] = faq.split(">>answer-");

                if (!question || !answer) continue;

                question = question.trim();
                answer = answer.trim();

                result.push({ type: "question", question, answer });
            }
        }

        console.log(result);
        return result;
    }

    $: items = [];

    (async () => {
        items = await getHelpContent();
    })();

    let search2 = "";

    const searchStringInput = e => {
        search2 = e.target.value;
    };

    const onClearSearchClick = () => {
        search2 = "";
    }

    let showHeadings = true;

    $: showHeadings = search2 != "";
</script>

<style>
	.container {
		display: flex;
		flex-flow: column nowrap;
        max-width: 800px;
        width: 100%;
        align-self: center;
	}

    .faqTitle {
        font-weight: 200;
        font-size: 50px;
        line-height: 90%;
        margin-top: 100px;
        margin-bottom: 70px;
        padding: 20px;
    }

    .httpiness {
        width: 140px;
        height: 26px;        
        display: inline-block;
        position: relative;
        top: 6.5px;
        background-position: center left;
        background-size: contain;
        background-repeat:no-repeat;
        background-image: url('./../images/wordmark.svg');
    }

    .search-container {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    .search {
        flex: 1 1 1px;
        font-family: "Mukta", sans-serif;
        font-size: 18px;
        padding: 5px 15px;
        color: #023047;
        line-height: 18px;
    }

    .search-clear {
        font-size: 50px;
        cursor: pointer;
        padding: 10px;
        padding-bottom: 15px;
    }
</style>

<div class="container">
    <div class="faqTitle">
        <a href="/"><span class="httpiness" /> </a><br>
        Frequently asked questions
    </div>
    <div class="search-container">
        <input class="search" type="text" value={search2} on:input={searchStringInput} placeholder="Search..." />
        <div on:click={onClearSearchClick} class="search-clear">×</div>
    </div>

    {#each items as item}
        {#if item.type == "section"}
            {#if !showHeadings}
                <Heading title={item.title} />
            {/if}
        {:else if item.type == "question"}
            <Question search={search2} question={item.question} answer={item.answer} />
        {/if}
    {/each}
</div>
